import React, { useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';
import Header from '../components/Header';



const MyPage = () => {
   
    
  return (
    <div> 
        <Header></Header>
      <Container>
        <MyBox>
        <h1> 마이 페이지</h1>
        <Hr/>
        <ProfileBox>
            <ProfileImgBox>
                P
            </ProfileImgBox>
            <ProfileInfoBox>
                    info
            </ProfileInfoBox>
            <ProfileMoreBtn>
                프로필 설정 〉
            </ProfileMoreBtn>

        </ProfileBox>
        <Hr/>

        </MyBox>
       

      </Container>
   <Footer></Footer>
    </div>
  );
};

export default MyPage;


const Container  = styled.div`
width:100%;
display: flex;
align-items:center;
justify-content:center;
`

const LoginForm = styled.div`
width:638px;
height:78vh;
display: flex;
align-items:center;
justify-content:center;
flex-direction: column;

`;


// 폼 그룹 스타일
export const Form = styled.form`

width:430px;
`;

export const FormGroup = styled.div`
    margin-bottom: 16px;
    position: relative;

    input {
        border-color: ${(props) => (props.focused ? "#3C3D37" : "#c1c1c1")};
    }
`;

export const Label = styled.label`
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
`;

// 입력 필드 스타일
export const Input = styled.input`
    width: 99%;
    height:56px;
   
    font-size: 14px;
    border: 1px solid #c1c1c1;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.3s ease-in-out;

    &:focus {
        border-color: #3C3D37;
    }
`;

// 로그인 버튼 스타일
export const LoginButton = styled.button`
margin-bottom:15px;
    width: 100%;
    height:56px;
    font-size: 16px;
    color: #fff;
    background-color: #3C3D37;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: #2e2e2b;
    }
`;

export const LoginKakaoButton = styled.button`
margin-bottom:15px;
    width: 100%;
    height:56px;
    font-size: 16px;
    color:#191919;
    background-color: #FEE500;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: #F9D933;
    }
`;

export const LoginGoogleButton = styled.button`
    margin-bottom:15px;
    width: 100%;
    height:56px;
    font-size: 16px;
    border: 1px solid #747775;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: #c1c1c1;
    }
`;

const Hr = styled.div`
width:98%;
border: 1px solid #3C3D37;
margin-bottom:15px;
`;


const MyBox = styled.div`
width:1284px;
background-color:green;
`;

const ProfileBox = styled.div`
width:100%;
background-color:pink;
display:flex;
`


const ProfileImgBox = styled.div`
width:90px;
height:90px;
margin-top:30px;
margin-bottom:30px;
margin-left:30px;
background-color:blue;
display: flex;
align-items:center;
justify-content:center;

`;
const ProfileInfoBox = styled.div`
width:300px;
height:90px;
margin-top:30px;
margin-bottom:30px;
background-color:red;
display: flex;
align-items:center;
justify-content:center;
`;
const ProfileMoreBtn = styled.div`
background-color:gray;
width:200px;
height:90px;
margin-top:30px;
margin-right:30px;
margin-left: auto; /* 오른쪽으로 밀어내기 */
display: flex;
align-items:center;
justify-content:end;

`;